// Renders a verdict after Claude vision evaluates a submission.
// Audio commentary lands inline with the verdict in Phase 4 — the
// verifier endpoint renders the wilman_commentary text via ElevenLabs
// before responding, and the URL ships on the submission record.

import VoicePlayer from './VoicePlayer.jsx';

export default function Verdict({ submission }) {
  if (!submission) return null;
  const { verified, points, reason, bonuses, wilman_commentary, confidence, audio_url, audio_duration } = submission;
  const tone = verified ? 'success' : 'danger';
  const labelClass =
    tone === 'success'
      ? 'border-success/40 bg-success/10 text-success'
      : 'border-danger/40 bg-danger/10 text-danger';

  return (
    <article className="card border-l-4 border-l-copper">
      <header className="flex items-center justify-between border-b border-border-tertiary px-4 py-3">
        <span className={`rounded-full border px-3 py-0.5 font-mono text-[10px] uppercase tracking-wider ${labelClass}`}>
          {verified ? 'verified' : 'rejected'}
        </span>
        <span className="font-mono text-[11px] uppercase tracking-wider text-fg-tertiary">
          {points >= 0 ? '+' : ''}
          {points} pts {Number.isFinite(confidence) && `· conf ${(confidence * 100).toFixed(0)}%`}
        </span>
      </header>

      <div className="space-y-3 px-4 py-4">
        <p className="font-serif italic text-fg-primary">&ldquo;{wilman_commentary || reason}&rdquo;</p>

        {audio_url && <VoicePlayer url={audio_url} duration={audio_duration} label="play verdict" />}

        {wilman_commentary && reason && (
          <p className="font-mono text-[11px] uppercase tracking-wider text-fg-tertiary">
            verifier note · <span className="normal-case tracking-normal text-fg-secondary">{reason}</span>
          </p>
        )}

        {bonuses?.length > 0 && (
          <ul className="space-y-1 font-mono text-[11px] uppercase tracking-wider text-fg-tertiary">
            {bonuses.map((b) => (
              <li key={b.condition}>
                bonus · <span className="text-fg-secondary">+{b.points}</span>
                <span className="ml-1 normal-case tracking-normal text-fg-tertiary">
                  &ldquo;{b.addendum || b.condition.replace(/_/g, ' ')}&rdquo;
                </span>
              </li>
            ))}
          </ul>
        )}

        <p className="font-serif italic text-sm text-fg-tertiary">— Mr. Wilman</p>
      </div>
    </article>
  );
}
